// Accepts values like "$1,234.56", "1234.56", " 45.00 " and strips currency
// symbols/thousands separators before parsing, so formatted spreadsheet cells
// don't silently collapse to 0.
export const parsePrice = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const cleaned = String(value).replace(/[^0-9.\-]/g, '');
  if (!cleaned) return 0;
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
};

// One entry per line: `part number` alone, or `part number, list price,
// customer price` (comma or tab separated, forgiving of a spreadsheet paste).
// Either price may be omitted and defaults to 0, left for the tenant to fill
// in on the review step.
export const parseEntries = (raw) => {
  const partNumbers = [];
  const prices = {};
  String(raw || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .forEach((line) => {
      const [code, listPrice, customerPrice] = line.split(/[,\t]+/).map((s) => (s || '').trim());
      if (!code) return;
      partNumbers.push(code);
      if (listPrice || customerPrice) {
        prices[code] = {
          list_price: parsePrice(listPrice),
          customer_price: parsePrice(customerPrice),
        };
      }
    });
  return { partNumbers, prices };
};

// Header names obvious enough to auto-map without asking the user.
const FIELD_PATTERNS = {
  partNumber: /part\s*#|part\s*no\.?$|part\s*number|^sku$|item\s*(number|code)|product\s*(code|number|id)|^mpn$|^part$/i,
  listPrice: /list\s*price|^msrp$|retail\s*price|^list$|^price$|unit\s*price/i,
  cost: /^cost$|unit\s*cost|customer\s*price|sell(ing)?\s*price|our\s*cost|dealer\s*price|dealer\s*cost/i,
};

export const detectColumnMap = (headers) => {
  const map = { partNumber: null, listPrice: null, cost: null };
  headers.forEach((header, idx) => {
    const cell = String(header || '').trim();
    Object.entries(FIELD_PATTERNS).forEach(([field, pattern]) => {
      if (map[field] === null && pattern.test(cell)) {
        map[field] = idx;
      }
    });
  });
  return map;
};

export const entriesFromFile = (dataRows, colMap) => {
  const partNumbers = [];
  const prices = {};
  dataRows.forEach((row) => {
    const code = String(row[colMap.partNumber] ?? '').trim();
    if (!code) return;
    partNumbers.push(code);
    const hasListPrice = colMap.listPrice !== null && colMap.listPrice !== undefined;
    const hasCost = colMap.cost !== null && colMap.cost !== undefined;
    if (hasListPrice || hasCost) {
      prices[code] = {
        list_price: hasListPrice ? parsePrice(row[colMap.listPrice]) : 0,
        customer_price: hasCost ? parsePrice(row[colMap.cost]) : 0,
      };
    }
  });
  return { partNumbers, prices };
};
